$(document).ready(function(e) {	    
    
    $('.s4_slider').slick({
        dots: false,
        slidesToShow:1,
        slidesToScroll: 1,
        variableWidth: false,
        centerMode: false,
        arrows:true,
        autoplay: false,
    });
    
    
    $('.review_slide_row').slick({
        dots: false,
        slidesToShow:4,
        slidesToScroll: 1,
        adaptiveHeight: false,
        variableWidth: false,
        centerMode: false,
        arrows:false,
        autoplay: false,
        responsive: [
            {
                breakpoint: 1021,
                settings: {
                slidesToShow:3,
            }
            },
            
            {
                breakpoint: 767,
                settings: {
                slidesToShow:1,
                variableWidth: true,
                centerMode: true,
            }
            },
        ] 
    });
            
    $('.package_slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '.package_slider_nav',
        autoplay: false,
        autoplaySpeed: 11000,
        dots: false,
        adaptiveHeight:true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                arrows: true,
            }
        }
        ]
    });

    $('.package_slider_nav').slick({
        slidesToShow:6,
        slidesToScroll: 1,
        asNavFor: '.package_slider',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        infinite: true,
        arrows: false,
        rtl: false,
    });	
    
    
    
    // Pause all videos before slide change
    $('.package_slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.package_slider .slider-video').each(function(){
            this.pause();
            this.currentTime = 0; // reset to start
        });
    });
    
    // Play video if slide contains video after change
    $('.package_slider').on('afterChange', function(event, slick, currentSlide){
        var $currentSlide = $(slick.$slides[currentSlide]);
        var $video = $currentSlide.find('.slider-video');
        if($video.length){
            $video.get(0).play();
        }
    });
    
        
    // <!-------------PKG_OPT-------------------->	
    
        
    $('.bundle_col').click(function(e) {
        $('.pkg_price').html($(this).attr("data-price"));
        $('.gift-price').html($(this).attr("data-gift"));
    });	
    
    
    // track if Kit4 ("All 4") was already auto-applied once
    let kit4AppliedOnce = false;

    // ==========================
    // DEFAULT LOAD
    // ==========================
    // NOTE: kit3 ("Any 3") is the default-active tier per the current markup.
    // Since kit3 no longer means "select every collection" (now that there
    // are 4 total), it does NOT auto-select anything on load - the customer
    // picks their 3 manually, same as Duo/Single already work.
    // Only kit4 ("All 4 Kits") auto-selects everything, since that's the
    // only tier where "select all" is still unambiguous.
    if ($('.bundle_col.kit4').hasClass('active')) {
        selectAllPackages();
        kit4AppliedOnce = false;
    }
    updatePackageButtonVisibility();

    // ==========================
    // BUNDLE CLICK
    // ==========================
    $('.bundle_col').click(function () {
        // make bundle active
        $('.bundle_col').removeClass('active');
        $(this).addClass('active');

        // reset all packages
        resetPackages();

        // KIT4 logic ("All 4 Kits" - auto-select everything)
        if ($(this).hasClass('kit4')) {
            if (!kit4AppliedOnce) {
                selectAllPackages();
                kit4AppliedOnce = false;
            }
        }
        // kit3 / kit2 / kit1 all require manual selection - no auto-select
        updatePackageButtonVisibility();
    });

    // ==========================
    // PACKAGE CLICK
    // ==========================
    $('.package_col').click(function () {
        let activeKit = $('.bundle_col.active');

        // toggle clicked package
        $(this).toggleClass('active');
        let checkbox = $(this).find('.pck-bx-rad');
        checkbox.prop('checked', $(this).hasClass('active'));

        // enforce kit2 (Duo) limit
        if (activeKit.hasClass('kit2') && $('.package_col.active').length > 2) {
            $(this).removeClass('active');
            checkbox.prop('checked', false);
            alert("You can select only 2 packages for Duo");
        }

        // enforce kit3 (Any 3) limit
        if (activeKit.hasClass('kit3') && $('.package_col.active').length > 3) {
            $(this).removeClass('active');
            checkbox.prop('checked', false);
            alert("You can select only 3 packages for this bundle");
        }

        // enforce kit1 (Single) limit
        if (activeKit.hasClass('kit1') && $('.package_col.active').length > 1) {
            $(this).removeClass('active');
            checkbox.prop('checked', false);
            alert("You can select only 1 package for Single");
        }

        updatePackageButtonVisibility();

    });

    // ========================
    // HELPER FUNCTIONS
    // ========================
    function updatePackageButtonVisibility() {
        let activeKit = $('.bundle_col.active');

        const activeCount = $('.package_col.active').length;

        const shouldShow =
            (activeKit.hasClass('kit1') && activeCount == 1) ||
            (activeKit.hasClass('kit2') && activeCount == 2) ||
            (activeKit.hasClass('kit3') && activeCount == 3) ||
            (activeKit.hasClass('kit4') && activeCount == 4);

        if (shouldShow) {
            $('.pckg-btn').show();
        } else {
            $('.pckg-btn').hide();
        }
    }

    function resetPackages() {
        $('.package_col').removeClass('active');
        $('.pck-bx-rad').prop('checked', false);
    }

    function selectAllPackages() {
        $('.package_col').each(function () {
            $(this).addClass('active');
            $(this).find('.pck-bx-rad').prop('checked', true);
        });
    }

        
    

    //accordion JS 
    $(".accordion").click(function() {
        
        var questionDiv = $(this);
        var answerDiv   = $(this).next('.acdn-content');
        var idx = $('.acdn-content').index(answerDiv);
        
        $('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
                $(ansDiv).slideUp(500, function() {
                    $(ansDiv).prev('.accordion').removeClass('accordion-open');
                });
            }
        });
                    
        if (answerDiv.is(':visible')) {
            answerDiv.stop().slideUp(500, function() {
                questionDiv.removeClass('accordion-open');
            });
        } else {
        questionDiv.addClass('accordion-open');
        answerDiv.stop().slideDown(500);
        }
    });
    
    var video = $('#myVdo video')[0];
    
    $('.ugc1').click(function(e) {
        $('.ugc-modal').addClass('active');
        $('.video-container').show();
        
        var videoFile = $(this).attr('data-vdo');
        video.src = videoFile;
        video.load();
        video.play();
    });	
    
    $('.ugc-close, .ugc-modal').click(function(e) {
        video.src = '';
        $('.ugc-modal').removeClass('active');
        $('.video-container').hide();
    });
    
    
    
    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#package").offset().top - 0
        }, 2000);
    });
    
    
    
    
    //POPUP_SLIDER
    
    
    $('.pop-close').click(function(e) {
        $('.collection_popup').hide();
    });
    
    $('.pakg_note').click(function(e) {
        $('.collection_popup').show();
        e.stopPropagation();
    });
    
    
    // Select all toggle elements and main item elements
    const toggles = document.querySelectorAll('.pakg_note');
    const mainItems = document.querySelectorAll('.collect_col');
    
    // Add click event listeners to each toggle
    toggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default link behavior
            
    
            // Get the data-comp attribute of the clicked toggle
            const targetComp = toggle.getAttribute('data-id');
    
            // Remove active class from all toggles and main items
            toggles.forEach(t => t.classList.remove('active'));
            mainItems.forEach(item => item.classList.remove('active'));
    
            // Add active class to the clicked toggle
            toggle.classList.add('active');
    
            // Find and activate the corresponding main item
            mainItems.forEach(item => {
                if (item.getAttribute('data-id') === targetComp) {
                    item.classList.add('active');
                }
                $(".colection_pop_slider").slick("refresh");
            });
        });
    });

    
    
    $('.colection_pop_slider').slick({
        dots: false,
        slidesToShow:1,
        slidesToScroll: 1,
        variableWidth: false,
        centerMode: false,
        arrows:true,
        autoplay: false,
    });
    





});